<template>
  <div class="air_ListBox">
    <div class="search-form">
      <el-row type="flex" :gutter="20" align="middle">
        <el-col class="flex-center-start">
          <el-form
            :model="formData"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            :inline="true"
            class="flex-center-end"
          >
            <el-form-item label="票号查询:" prop="ticketNumber">
              <el-input v-model="formData.ticketNumber" style="width:200px" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="getDetail(formData.ticketNumber)">导入</el-button>
            </el-form-item>
            <el-form-item>
              <p style="color:red;font-size:10px">暂不支持国际票</p>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <div class="content-box" v-if="show">
      <div class="content-box-title">行程通知单</div>
      <div style="border-top:1px solid #dfdfdf;border-bottom:1px solid #dfdfdf">
        <div class="content-box-info flex-center-end">
          <div class="content-box-info-item">
            <span>旅客姓名：</span>
            <el-input style="width:200px" v-model="detail.psgName"></el-input>
          </div>
          <div class="content-box-info-item">
            <span>证件号码：</span>
            <el-input style="width:200px" v-model="detail.cardNo"></el-input>
          </div>
          <div class="content-box-info-item">
            <span>签注：</span>
            <el-input style="width:200px" v-model="detail.remark"></el-input>
          </div>
        </div>
        <div class="content-box-info">
          <el-table :data="detail.newSegmentList" style="width: 100%" stripe>
            <el-table-column prop="depCityName" label="始发地/目的地" width="120" align="center">
              <template slot-scope="scope">
                <div class="flex-center-end">
                  <p style="padding-right:5px">{{scope.row.statu==0?'自':'至'}}</p>
                  <el-input v-model="scope.row.cityName" maxlength="10"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="airlineName" label="承运人" align="center" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.airlineName"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="flightNo" label="航班号" align="center" width="90">
              <template slot-scope="scope">
                <el-input v-model="scope.row.flightNo" maxlength="10"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="cabin" label="座位等级" align="center" width="80">
              <template slot-scope="scope">
                <el-input v-model="scope.row.cabin" maxlength="5"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="日期" width="110" align="center">
              <template slot-scope="scope">
                <div>
                  <el-input v-model="scope.row.date" maxlength="10"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="time" label="时间" width="90" align="center">
              <template slot-scope="scope">
                <div>
                  <el-input v-model="scope.row.time" maxlength="5"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="ticketType" label="客票类型" width="80" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.ticketType" maxlength="8"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="effectiveDate" label="客票生效日期" width="110" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.effectiveDate" maxlength="10"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="deadlineDate" label="有效截止日期" width="110" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.deadlineDate" maxlength="10"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="luggage" label="免费行李" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.luggage" maxlength="4"></el-input>
              </template>
            </el-table-column>
          </el-table>
          <!-- <table>
                    <tr>
                        <th>始发地/目的地</th>
                        <th>承运人</th>
                        <th>航班号</th>
                        <th>座位等级</th>
                        <th>日期</th>
                        <th>时间</th>
                        <th>客票类型</th>
                        <th>客票生效日期</th>
                        <th>有效截止日期</th>
                        <th>免费行李</th>
                    </tr>
                    <tr v-for="(item,index) in detail.segmentList" :key="index">
                        <td>
                            自
                             <el-input  maxlength="10"></el-input>
                        </td>
                        <td>
                            <el-input ></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="10"></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="5"></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="10"></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="10"></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="10"></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="10"></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="10"></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="10"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            至
                             <el-input  maxlength="10"></el-input>
                        </td>
                        <td>
                            <el-input ></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="10"></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="5"></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="10"></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="10"></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="10"></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="10"></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="10"></el-input>
                        </td>
                        <td>
                            <el-input  maxlength="10"></el-input>
                        </td>
                    </tr>
          </table>-->
        </div>
        <div
          class="content-box-info flex-center-end"
          style="border-bottom:1px solid #dfdfdf;padding-bottom:20px;"
        >
          <div class="content-box-info-item">
            <span>票价：</span>
            <el-input v-model="detail.ticketAmount"></el-input>
          </div>
          <div class="content-box-info-item">
            <span>机场建设费：</span>
            <el-input v-model="detail.airportTax"></el-input>
          </div>
          <div class="content-box-info-item">
            <span>燃油附加费：</span>
            <el-input v-model="detail.oilTax"></el-input>
          </div>
          <div class="content-box-info-item">
            <span>其他税费：</span>
            <el-input v-model="detail.otherTax"></el-input>
          </div>
          <div class="content-box-info-item">
            <span>合计：</span>
            <el-input v-model="detail.totalAmount"></el-input>
          </div>
        </div>
        <div
          class="content-box-info flex-center-end"
          style="border-bottom:1px solid #dfdfdf;padding-bottom:20px;"
        >
          <div class="content-box-info-item">
            <span>电子客票号码：</span>
            <el-input v-model="detail.ticketNumber"></el-input>
          </div>
          <div class="content-box-info-item">
            <span>验证码：</span>
            <el-input v-model="detail.verificationCode"></el-input>
          </div>
          <div class="content-box-info-item">
            <span>提示信息：</span>
            <el-input v-model="detail.promptMessage" maxlength="20"></el-input>
          </div>
          <div class="content-box-info-item">
            <span>保险费：</span>
            <el-input v-model="detail.insurance"></el-input>
          </div>
        </div>
        <div class="content-box-info flex-center-end">
          <div class="content-box-info-item">
            <span>销售单位代码：</span>
            <el-input v-model="detail.salesUnitCode"></el-input>
          </div>
          <div class="content-box-info-item">
            <span>填开单位：</span>
            <el-input v-model="detail.fillUnit"></el-input>
          </div>
          <div class="content-box-info-item">
            <span>填开日期：</span>
            <el-input v-model="detail.fillDate"></el-input>
          </div>
        </div>
      </div>
      <div class="content-btn flex-center">
        <div class="flex-center">
          <el-button type="warning" size="small" @click="saveTicket">导出或打印</el-button>
          <el-button type="info" size="small" @click="empty">清空</el-button>
        </div>
      </div>
    </div>
    <div class="warning-info" v-else>
      <p>行程单打印失败，可能由如下原因引起：</p>
      <p>a)您所使用的单号不是当前配置所属office所拥有；</p>
      <p>b)您所使用的单号已经使用过（系统会自动过号，重试即可）；</p>
      <p>c)您的客票已经打印过报销凭证，这时需要先作废原报销凭证，再进行打印；</p>
      <p>d)您的客票不存在，或已经过期、不能从主机系统提取得到，这时不能进行报销凭证打印操作；</p>
      <p>请核查后重新导入；</p>
      <p class="text">参考错误信息:无可用配置或繁忙，或配置无打印行程单功能</p>
    </div>
  </div>
</template>
<script>
import findItinerary from "@/lib/data-service/flight/flight_domestic_buyer_manage_itinerarOrder_findItinerary";
import pdfParam from "@/lib/data-service/flight/flight_domestic_buyer_manage_itinerarOrder_pdfParam";
import baseUrl from "yinzhilv-js-sdk/frontend/common-project/lib/common-service/get_url_prefix";
import { resolve } from "q";
export default {
  data() {
    var ticketNumberVerify = (rule, value, callback) => {
      const rsg = /(^([\d-]{13,14})*?)$/;
      if (value == "") {
        callback(new Error("请输入电子客票号"));
      } else if (!rsg.test(value)) {
        callback(
          new Error(
            "电子客票号输入有误! 票号的输入举例如下：“9992404665652” “999-2404665652”"
          )
        );
      } else {
        if (value.length >= 13) {
          callback();
        } else {
          callback(
            new Error(
              "电子客票号输入有误！票号的输入举例如下：“9992404665652” “999-2404665652”"
            )
          );
        }
      }
    };
    return {
      formData: {
        ticketNumber: ""
      },
      detail: {
        airportTax: "",
        cardNumber: "",
        fillDate: "",
        fillUnit: "",
        insurance: "",
        oilTax: "",
        otherTax: "",
        promptMessage: "",
        psgName: "",
        remark: "",
        salesUnitCode: "",
        ticketAmount: "",
        ticketNumber: "",
        totalAmount: "",
        verificationCode: "",
        newSegmentList: []
      },
      show: true,
      airLineList: [],
      rules: {
        ticketNumber: [
          { validator: ticketNumberVerify, required: true, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    getDetail(val) {
      let _this = this;
      let statu = true;
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          findItinerary({ ticketNumber: val }).then(res => {
            if (res.result) {
              this.detail = getList(res.result);
              delete this.detail.segmentGo;
              delete this.detail.segmentBack;
            }
            if (res.hasData == 2) {
              this.show = false;
            } else {
              this.show = true;
            }
          });
        } else {
          return false;
        }
      });

      function getList(params) {
        // params.segmentList.map(item => {
        let starFlight = params.segmentGo;
        let endFlight = params.segmentBack;
        let arr = [
          {
            airlineName: starFlight.airlineName,
            cabin: starFlight.cabin,
            cityName: starFlight.cityName,
            date: starFlight.date,
            deadlineDate: starFlight.deadlineDate,
            effectiveDate: starFlight.effectiveDate,
            flightNo: starFlight.flightNo,
            luggage: starFlight.luggage,
            segmentSerial: starFlight.segmentSerial,
            segmentType: starFlight.segmentType,
            ticketType: starFlight.ticketType,
            time: starFlight.time,
            statu: 0
          },
          {
            airlineName: endFlight.airlineName,
            cabin: endFlight.cabin,
            cityName: endFlight.cityName,
            date: endFlight.date,
            deadlineDate: endFlight.deadlineDate,
            effectiveDate: endFlight.effectiveDate,
            flightNo: endFlight.flightNo,
            luggage: endFlight.luggage,
            segmentSerial: endFlight.segmentSerial,
            segmentType: endFlight.segmentType,
            ticketType: endFlight.ticketType,
            time: endFlight.time,
            statu: 1
          }
        ];
        arr = [...arr];
        params.newSegmentList = arr;
        // });
        return params;
      }
    },
    saveTicket() {
      let list = this.detail;
      // if(!list.psgName)return
      // if(!list.cardNumber)return
      // if(!list.ticketNumber)return
      let data = JSON.parse(JSON.stringify(this.detail));
      let flightObj = {
        segmentBack: data.newSegmentList[1],
        segmentGo: data.newSegmentList[0]
      };
      data.segmentBack = flightObj.segmentBack;
      data.segmentGo = flightObj.segmentGo;
      for (var k in data) {
        if (
          k == "code" ||
          k == "hasData" ||
          k == "msg" ||
          k == "newSegmentList"
        ) {
          delete data[k];
        }
      }
      const environment = global.appConfig.environment;
      const urlPrefix = baseUrl({
        environment: environment,
        appKey: "flight"
      });
      pdfParam(data).then(res => {
        if (res.code == this.SUCCESS_CODE) {
          window.open(urlPrefix + res.html);
        }
      });
    },
    empty() {
      let list = this.detail;
      for (let x in list) {
        if (list[x] instanceof Array) {
          list[x].map(item => {
            for (let _i in item) {
              _i != "statu" ? (item[_i] = "") : "";
            }
          });
        } else {
          list[x] = "";
        }
      }
    }
  },
  activated() {
    let arr;
    this.airLineList = arr = [
      {
        airlineName: "",
        cabinCode: "",
        cityName: "",
        date: "",
        deadlineDate: "",
        effectiveDate: "",
        flightNo: "",
        luggage: "",
        ticketType: "",
        time: "",
        statu: 1
      },
      {
        airlineName: "",
        cabinCode: "",
        cityName: "",
        date: "",
        deadlineDate: "",
        effectiveDate: "",
        flightNo: "",
        luggage: "",
        ticketType: "",
        time: "",
        statu: 1
      }
    ];
    let arr2 = JSON.parse(JSON.stringify(arr));
    arr2[0].statu = 0;
    this.detail.newSegmentList.length = 0;
    this.detail.newSegmentList.push(...arr2);
    let ticketNumber = this.$route.query.ticketNumber;
    ticketNumber
      ? ((this.formData.ticketNumber = ticketNumber),
        this.$nextTick(() => {
          this.getDetail(ticketNumber);
        }))
      : "";
  }
};
</script>
<style lang="less" scoped>
.air_ListBox {
  border-top: 3px solid #237dc9;
  width: 100%;
  /deep/.el-input {
    width: 120px;
    input {
      width: 100%;
      height: 30px;
      border-radius: 0;
    }
    .el-input__suffix {
      display: flex;
      align-items: center;
    }
  }

  .content-btn {
    margin: 30px 0;
  }
  .el-button {
    border-radius: 0;
    display: flex;
    height: 30px;
    align-items: center;
  }
  .content-box {
    border: 1px solid #dfdfdf;
    .content-box-title {
      padding: 20px 0;
      font-size: 20px;
      text-align: center;
      font-weight: bold;
      color: #237dc9;
      background: #f4f9ff;
    }
    .content-box-info {
      background: white;
      font-size: 14px;
      //   border-bottom: 1px solid #dfdfdf;
      padding: 5px 10px;
      margin: 10px;
      font-size: 10px;
      .el-table {
        /deep/.cell {
          color: black;
          font-weight: 400;
        }
        /deep/.el-input {
          width: 100%;
          input {
            padding: 0 5px;
            text-align: center;
          }
        }
      }
    }
  }
}
table {
  margin: auto;
  width: 100%;
  border-collapse: collapse;
  th {
    font-size: 13px;
    color: #333;
  }
  td {
    text-align: center;
    font-size: 12px;
    color: #333;
    i {
      font-style: normal;
      font-size: 10px;
    }
  }
}
table td,
table th {
  border: 1px solid #cad9ea;
  height: 30px;
}
.warning-info {
  padding: 30px 100px;
  font-size: 14px;
  border: 1px solid #dfdfdf;
  background: #ffefeb;
  p {
    padding: 5px 0;
  }
  .text {
    padding: 30px 0;
    color: red;
  }
}
.search-form {
  padding: 20px;
  margin-bottom: 10px;
  background: #f4f9ff;
  span {
    width: 75px;
    font-size: 14px;
    display: inline-block;
  }
}
</style>
